/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Environment } from '../models/Environment';

/**
* Details about the resource\'s environment.
*/
export class EnvironmentDetails {
  'environment'?: Environment;
  /**
  * Whether the environment is manually overridden. If `true`, the environment is user-defined and remains static. If `false`, the environment is automatically detected and set by Eon. 
  */
  'isOverridden'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "environment",
      "baseName": "environment",
      "type": "Environment",
      "format": ""
    },
    {
      "name": "isOverridden",
      "baseName": "isOverridden",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EnvironmentDetails.attributeTypeMap;
  }

  public constructor() {
  }
}



